export const ENERGYMEASUREMENT_COMMUNICATION_MODULE = [
    'BACnetmodul MSTP/RS485 till UH50 WZU-485E-BAC',
    'Modbusmodul RTU/RS485 till UH50 WZU-485E-MOD',
    'M-bus Modul 2 puls WZU-MI',
    'M-bus Modul WZU-MB-G4'
]